import { render, staticRenderFns } from "./DnDisciplineManager.vue?vue&type=template&id=523384dc&scoped=true&"
import script from "./DnDisciplineManager.vue?vue&type=script&lang=js&"
export * from "./DnDisciplineManager.vue?vue&type=script&lang=js&"
import style0 from "./DnDisciplineManager.vue?vue&type=style&index=0&id=523384dc&lang=scss&scoped=true&"
import style1 from "./DnDisciplineManager.vue?vue&type=style&index=1&id=523384dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523384dc",
  null
  
)

export default component.exports